export enum InvoiceStages {
  New = "DT31_1:N",
  SentToCustomer = "DT31_1:S",
  Delayed = "DT31_1:1",
  Paid = "DT31_1:P",
  DoNotPay = "DT31_1:D",
}
